import React from "react"
import { sitka } from "../../redux/store"
import { DashHeader } from "../styled_components/dash_header"
import { appStrings } from "../../common/strings/app_strings"
import { GoogleCalendarItem } from "./google_calendar_item"
import { ZoomItem } from "./zoom/zoom_item"
import styled from "styled-components"
import {
    getTeamConfig,
    availableTeamsWithoutCalendarConfigs,
    teamHasConfig,
} from "../../util/google_calendar_config_utils"
import { colors } from "../../common/colors/app_colors"

const { aTagBlue, inactiveGray } = colors

const {
    connectedAppsListHeader,
    connectedAppsSubHeader,
} = appStrings.connectedApps

export const ConnectedAppsList = ({
    configs,
    zoomConfigs,
    teams,
    profile,
    tags,
}) => {
    const { googleCalendarConfigs: googleModule, zoomConfigs: zoomModule } = sitka.getModules()
    
    const {
        handleStartGoogleOauth,
        handleSelectGoogleCalendarConfig,
        handleSetPendingConfigTeamId,
        handleRemoveAccount,
        handleRemoveCalendar,
        handleUpdateConfigDescription,
        handleAddNewCalendar,
        handleUpdateTagKeywords,
        handleUpdateConfigTags,
        handleUpdateAttendeeUsers,
        handleUpdateCreateAllDayRecords,
        handleUpdateCreateRecordsForMembers,
        handleDeleteConfig,
    } = googleModule

    const {
        handleStartZoomOauth,
        handleZoomSetPendingConfigTeamId,
        handleDeleteZoomConfig,
        handleSelectZoomConfig,
    } = zoomModule

    const { sort, items, selected, pendingConfigTeamId } = configs
    const { sort: zoomSort, items: zoomItems, selected: zoomSelected } = zoomConfigs

    const availableTeams = availableTeamsWithoutCalendarConfigs(
        profile,
        teams,
        configs,
    )
    const showCreateNewConfigItem = !!availableTeams.length
    const personalTeam = Object.values(teams.items).find(t => t.isPersonal)
    const showCreateNewZoomConfigItem = !teamHasConfig(zoomConfigs, personalTeam.id)
    return (
        <div>
            <DashHeader>
                <h4>{connectedAppsListHeader}</h4>
                <p>{connectedAppsSubHeader}</p>
            </DashHeader>
            <CalendarItemListWrapper>
                {sort &&
                    sort.map((configId) => {
                        const config = items[configId]
                        const configTeam = teams.items[config.teamId]
                        return (
                            <GoogleCalendarItem
                                key={configId}
                                handleSelectGoogleCalendarConfig={
                                    handleSelectGoogleCalendarConfig
                                }
                                selected={selected}
                                team={getTeamConfig(teams, config.teamId)}
                                configs={configs}
                                config={config}
                                profile={profile}
                                handleStartGoogleOauth={handleStartGoogleOauth}
                                handleRemoveAccount={handleRemoveAccount}
                                handleRemoveCalendar={handleRemoveCalendar}
                                handleSetDescription={handleUpdateConfigDescription}
                                handleAddNewCalendar={handleAddNewCalendar}
                                handleUpdateTagKeywords={handleUpdateTagKeywords}
                                handleUpdateAttendeeUsers={handleUpdateAttendeeUsers}
                                handleUpdateCreateAllDayRecords={handleUpdateCreateAllDayRecords}
                                handleUpdateCreateRecordsForMembers={handleUpdateCreateRecordsForMembers}
                                handleDeleteConfig={handleDeleteConfig}
                                teams={teams}
                                tags={tags}
                                handleUpdateConfigTags={handleUpdateConfigTags}
                                configTeam={configTeam}
                            />
                        )
                    })}
                {showCreateNewConfigItem && (
                    <GoogleCalendarItem
                        selected={selected}
                        handleSelectGoogleCalendarConfig={
                            handleSelectGoogleCalendarConfig
                        }
                        configs={configs}
                        handleStartGoogleOauth={handleStartGoogleOauth}
                        handleSetPendingConfigTeamId={
                            handleSetPendingConfigTeamId
                        }
                        availableTeams={availableTeams}
                        pendingConfigTeamId={pendingConfigTeamId}
                        handleRemoveAccount={handleRemoveAccount}
                        handleRemoveCalendar={handleRemoveCalendar}
                        handleAddNewCalendar={handleAddNewCalendar}
                    />
                )}
                {zoomSort &&
                    zoomSort.map((configId) => {
                        const config = zoomItems[configId]
                        return (
                            <ZoomItem
                                key={configId}
                                handleSelectZoomConfig={handleSelectZoomConfig}
                                selected={zoomSelected}
                                team={getTeamConfig(teams, config.teamId)}
                                config={config}
                                handleStartZoomOauth={handleStartZoomOauth}
                                handleDeleteConfig={handleDeleteZoomConfig}
                            />
                        )
                    })}
                {showCreateNewZoomConfigItem && (
                    <ZoomItem
                        selected={zoomSelected}
                        handleSelectZoomConfig={handleSelectZoomConfig}
                        configs={zoomConfigs}
                        handleStartZoomOauth={handleStartZoomOauth}
                        handleSetPendingConfigTeamId={handleZoomSetPendingConfigTeamId}
                        pendingConfigTeamId={personalTeam.id}
                    />
                )}
            </CalendarItemListWrapper>
        </div>
    )
}

const CalendarItemListWrapper = styled.div`
    margin-top: 20px;
    .link {
        cursor: pointer;
        color: ${aTagBlue};
    }
    .inactive-link {
        color: ${inactiveGray};
        cursor: not-allowed;
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/connected_apps_list.jsx